module.exports = __webpack_public_path__ + "static/weather-tablet-light-plp-9e99f381fbee08c775026b00ed2b59a9.png";